// Local technical diagnostics only; never log Error objects, identities or credentials.
const CODES = new Set([
  "auth/invalid-credential", "auth/wrong-password", "auth/user-not-found",
  "auth/network-request-failed", "auth/too-many-requests", "auth/internal-error",
  "auth/popup-closed-by-user", "auth/popup-blocked", "auth/cancelled-popup-request",
  "auth/multi-factor-auth-required",
  "auth/invalid-multi-factor-session", "auth/missing-multi-factor-session",
  "auth/invalid-verification-code", "auth/code-expired", "auth/session-expired",
  "auth/firebase-app-check-token-is-invalid", "auth/invalid-app-credential",
]);
export function recordAuthFailure(stage, error, startedAt) {
  const code = CODES.has(error?.code) ? error.code :
    ["QuotaExceededError", "SecurityError"].includes(error?.name) ? "storage-unavailable" : "unknown";
  console.warn("AXORIS sign-in diagnostic", JSON.stringify({ stage, code, durationMs: Math.max(0, Date.now() - startedAt) }));
}
export function signInErrorKind(error) {
  return ["auth/network-request-failed", "auth/too-many-requests", "auth/internal-error", "auth/firebase-app-check-token-is-invalid", "auth/invalid-app-credential"].includes(error?.code)
    ? "unavailable" : "credentials";
}
